<template>
  <div class="header-tools__wrapper typography__body2">
    <template v-if="!hideLanguageSwitcher">
      <TheHeaderSiteLanguageSwitcher
        :class="[isMobileMenu ? `language-switcher` : `language-switcher__desktop`]"
        :is-main-site="true"
      />
    </template>

    <BaseModalButton
      :class="[isMobileMenu ? `header__login` : `header__desktop`]"
      :modal="SHARED_MODAL.AuthLogin"
    >
      {{ t("header.login") }}
    </BaseModalButton>

    <BaseModalButton
      class="header__registration"
      :class="{ menu: isMobileMenu }"
      :modal="MODAL.AuthRegistration"
      @click="() => trackSignUpStarted('header_registration')"
    >
      {{ t("header.registration") }}
    </BaseModalButton>
  </div>
</template>

<script setup lang="ts">
defineProps<Props>();

const { t } = useI18n();
const { trackSignUpStarted } = useAnalytics();

interface Props {
  isMobileMenu?: boolean;
  hideLanguageSwitcher?: boolean;
}
</script>

<style scoped>
.header-tools__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 8px;
}

@media (--desktop) {
  .header-tools__wrapper {
    flex-direction: row;
    column-gap: 8px;
  }
}

.language-switcher__desktop {
  display: none;
}

.header__desktop {
  display: none;
}

@media (--desktop) {
  .header__desktop {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 24px;
  }
  .language-switcher__desktop {
    display: flex;
  }
}

@media (--hover) {
  .header__desktop:hover,
  .header__desktop:active {
    color: var(--orange-3);
  }
}

.header__registration {
  color: var(--grey-1);
}

@media (--desktop) {
  .header__registration {
    padding: 8px 24px;
    color: var(--white);
    border-radius: 20px;
    background-color: var(--grey-1-5);
  }

  @media (--hover) {
    .header__registration:hover {
      background-color: var(--grey-2);
    }

    .header__registration:active {
      background-color: var(--grey-1);
    }
  }
}

.header__login {
  width: 100%;
  padding: 8px 24px;
  color: var(--grey-1-5);
  border: 1px solid var(--grey-1-5);
  border-radius: 20px;
}

@media (--hover) {
  .header__login:hover,
  .header__login:focus-visible,
  .header__login:active {
    color: var(--white);
    background-color: var(--grey-1-5);
  }
}

.header__registration.menu {
  width: 100%;
  padding: 8px 24px;
  color: var(--white);
  border: 1px solid var(--grey-1-5);
  border-radius: 20px;
  background-color: var(--grey-1-5);
}

@media (--hover) {
  .header__registration.menu:hover,
  .header__registration.menu:active {
    background-color: var(--grey-1);
  }
}
</style>
